import React, { useEffect } from 'react';
import LoginForm from './components/login_form/LoginForm';
import Dashboard from './components/dashboard/Dashboard';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";

const LegacyRedirect = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/dashboard?tab=update', { replace: true });
  }, [navigate]);
  return <div style={{ color: '#ECF0F5', padding: 20 }}>Redirecting to dashboard…</div>;
};

const AuthGuard = ({ children }) => {
  let ok = false;
  try {
    ok = typeof window !== 'undefined' && window.sessionStorage.getItem('isAuthenticated') === 'true';
  } catch (_) {}
  if (!ok) return <Navigate to="/" replace />;
  return children;
};

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginForm />} />
        <Route path="dashboard/" element={
          <AuthGuard>
            <Dashboard />
          </AuthGuard>
        } />
        <Route path="updateForm/" element={<LegacyRedirect />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
